<template>
  <div dir="rtl" class="mr-8 px-4 sm:px-6 lg:px-8">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">الدارسين المفعلين</h1>
        <p class="mt-2 text-sm text-gray-700"></p>
      </div>
    </div>

    <div class="mt-2 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
      <select @change="changeSessionsId(masterSessionValue)" id="country" name="country" autocomplete="country-name"
        class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm pr-7"
        v-model="masterSessionValue">
        <option disabled value="" selected>الرجاء اختيار الجلسة</option>
        <option v-for="master in masterSessionsList" :key="master.id" :value="master.id">
          {{ master.sessionsName }}</option>
      </select>

      <div> 
        <button class="button" type="submit" @click="getAllNewStudents()" :disabled="isLoading">
          {{ isLoading ? 'جاري البحث...' : 'بحث' }}
        </button>
      </div>

    </div>


    <div class="mt-8 flex flex-col">
      <div class="sm:flex-auto">
        <h1 class="text-lg font-medium text-gray-900"> الحسابات المفعلة</h1>
        <p class="mt-2 text-xs text-gray-700"></p>
      </div>

      <div v-if="!this.errorMessageStatus" class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="min-w-full divide-y divide-customHafadhColor">
              <thead class="bg-customHafadhColor text-center">
                <tr>
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    الاسم
                  </th>
                  <!--
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    الايميل
                  </th>
                  --->
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    الجوال
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    المسار
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    مدة الاشتراك
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    التعليم
                  </th>
                  <!--
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    الهوية
                  </th>
                  --->
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    حالة الانسحاب
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    حالة الدارس
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    نسخة التطبيق
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    منصة التطبيق
                  </th>
                  <!--
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    تغير الرقم السري
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    تغير بيانات الدارس
                  </th>
                  --->
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white">
                <tr v-for=" (student, index) in students" :key="index">
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                    {{ student.fullName }}
                  </td>
                  <!--
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    {{ student.email }}
                  </td>
                  --->
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    {{ student.phone }}
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    {{ student.massaratValue }}
                  </td>
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                    {{ student.engagementPreference }}
                  </td>
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                    {{ student.qualificationValue }}
                  </td>
                  <!--
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                    {{ student.nationalId }}
                  </td>
                  --->
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                    <Switch @click="onClickStatusOfCanWithdraw(index, !student.canWithdraw)"
                      v-model="student.canWithdraw" :class="[
          student.canWithdraw ? 'bg-blue-600' : 'bg-gray-200',
          'mr-2 relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500',
        ]">
                      <span class="sr-only"></span>
                      <span :class="[
          student.canWithdraw ? '-translate-x-5' : 'translate-x-0',
          'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
        ]">
                        <span :class="[
          student.canWithdraw
            ? 'opacity-0 ease-out duration-100'
            : 'opacity-100 ease-in duration-200',
          'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity',
        ]" aria-hidden="true">
                          <svg class="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12">
                            <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2"
                              stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </span>
                        <span :class="[
          student.canWithdraw
            ? 'opacity-100 ease-in duration-200'
            : 'opacity-0 ease-out duration-100',
          'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity',
        ]" aria-hidden="true">
                          <svg class="h-3 w-3 text-blue-600" fill="currentColor" viewBox="0 0 12 12">
                            <path
                              d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                          </svg>
                        </span>
                      </span>
                    </Switch>
                  </td>
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                    <Switch @click="onClickStatusOfStudent(index, !student.isEnabled)" v-model="student.isEnabled"
                      :class="[
          student.isEnabled ? 'bg-blue-600' : 'bg-gray-200',
          'mr-2 relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500',
        ]">
                      <span class="sr-only"></span>
                      <span :class="[
          student.isEnabled ? '-translate-x-5' : 'translate-x-0',
          'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
        ]">
                        <span :class="[
          student.isEnabled
            ? 'opacity-0 ease-out duration-100'
            : 'opacity-100 ease-in duration-200',
          'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity',
        ]" aria-hidden="true">
                          <svg class="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12">
                            <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2"
                              stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </span>
                        <span :class="[
          student.isEnabled
            ? 'opacity-100 ease-in duration-200'
            : 'opacity-0 ease-out duration-100',
          'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity',
        ]" aria-hidden="true">
                          <svg class="h-3 w-3 text-blue-600" fill="currentColor" viewBox="0 0 12 12">
                            <path
                              d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                          </svg>
                        </span>
                      </span>
                    </Switch>
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <div v-if="student.appVersion" class="flex flex-col">
                      <span class="font-medium">{{ student.appVersion }}</span>
                      <span v-if="student.appBuildNumber" class="text-xs text-gray-400">
                        (Build: {{ student.appBuildNumber }})
                      </span>
                      <span v-if="student.appVersionUpdatedAt" class="text-xs text-gray-400">
                        {{ formatDate(student.appVersionUpdatedAt) }}
                      </span>
                    </div>
                    <span v-else class="text-gray-400 italic">غير متاح</span>
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <span v-if="student.appPlatform" class="font-medium">
                      {{ student.appPlatform === 'android' ? 'Android' : student.appPlatform === 'ios' ? 'iOS' : student.appPlatform }}
                    </span>
                    <span v-else class="text-gray-400 italic">غير متاح</span>
                  </td>
                  <!--
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                    <button class="enabled-button" @click="openPopupPassword(index)">تغير</button>
                  </td>
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                    <button class="enabled-button" @click="openPopupChangeDetiles(index)">تغير</button>
                  </td>
                  --->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-if="this.errorMessageStatus">
        <h1 style="color: red;"> {{ this.errorMessage }}</h1>
      </div>
    </div>

    <!-- Password Popup -->
    <div v-if="showPopupPassword" class="popup" dir="rtl">
      <div class="popup-content">
        <h3 class="text-lg leading-6 font-medium text-gray-900">تغيير الرقم السري</h3>
        <div class="col-span-6 sm:col-span-3 mt-10">
          <label for="password" class="block text-sm font-medium text-gray-700">
            كلمة المرور
          </label>
          <input name="password" id="password" v-model="password" placeholder="الرقم السري"
            class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
            required oninvalid="this.setCustomValidity('الرجاء ادخال الرقم السري')" oninput="setCustomValidity('')"
            :type="showPassword ? 'text' : 'password'" @input="validatePassword" />
          <span v-if="passwordError" class="text-center text-red-500 text-xs">{{ passwordError }}</span>
        </div>
        <div class="col-span-6 sm:col-span-3 mt-5">
          <label for="confirmPassword" class="block text-sm font-medium text-gray-700">
            اعادة ادخال كلمة المرور
          </label>
          <input name="confirmPassword" id="confirmPassword" v-model="confirmPassword" placeholder="الرقم السري"
            class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
            required oninvalid="this.setCustomValidity('الرجاء ادخال الرقم السري')" oninput="setCustomValidity('')"
            :type="showPassword ? 'text' : 'password'" @input="validatePassword" />
          <span v-if="confirmPasswordError" class="text-center text-red-500 text-xs">{{ confirmPasswordError
            }}</span>
        </div>
        <div class="block text-sm font-medium text-gray-700 mt-5 mr-2">
          <input type="checkbox" v-model="showPassword" />
          عرض كلمة المرور
        </div>
        <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
          <button
            class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm"
            @click="submitPassword()" type="submit" :disabled="passwordSuccess"
            :class="{ 'cursor-not-allowed': passwordSuccess }">تم</button>
          <button
            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
            @click="closePopup" type="button">الغاء</button>
        </div>
      </div>
    </div>

    <!-- Change Detiles Popup -->
    <div v-if="showPopupChangeDetiles" class="popup" dir="rtl">
      <div class="popup-content">
        <h3 class="text-lg leading-6 font-medium text-gray-900">تغيير بيانات الدارس</h3>
        <div class="col-span-6 sm:col-span-3 mt-10">
          <label for="password" class="block text-sm font-medium text-gray-700">
            الايميل
          </label>
          <input name="email" id="email" v-model="email" placeholder="الايميل"
            class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
            required oninvalid="this.setCustomValidity('الرجاء ادخال الايميل')" oninput="setCustomValidity('')"
            @input="validateEmail" />
          <span class="text-center text-red-500 text-xs" v-if="emailError">{{ emailError
            }}</span>
        </div>
        <div class="col-span-6 sm:col-span-3 mt-5">
          <label for="confirmPassword" class="block text-sm font-medium text-gray-700">
            رقم الهاتف
          </label>
          <div class="mt-1 flex">
            <span
              class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">+966</span>
            <input type="text" name="phone" id="phone" v-model="phone" placeholder="رقم الهاتف"
              class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              required oninvalid="this.setCustomValidity('الرجاء رقم رقم الهاتف')" oninput="setCustomValidity('')"
              maxlength="9" minlength="9" />
          </div>
        </div>
        <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
          <button
            class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm"
            @click="submitDetiles()" type="submit">تم</button>
          <button
            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
            @click="closePopup" type="button">الغاء</button>
        </div>
      </div>
    </div>
  </div>







</template>
<script>
import url from '@/url';
import axios from 'axios';
import { defineComponent } from 'vue';

class masterSessionsDto {
  constructor(data) {
    this.id = data.id || null;
    this.sessionsId = data.sessionsId || null;
    this.sessionsName = data.sessionsName || null;
  }
}

class StudentDto {
  constructor(data) {
    this.id = data.id || null;
    this.email = data.email || null;
    this.fullName = data.fullName || null;
    this.engagementPreference = data.engagementPreference || null;
    this.qualificationValue = data.qualificationValue || null;
            // this.nationalId = data.nationalId || null; // Removed as it's not essential for app functionality
    this.canWithdraw = data.canWithdraw || false;
    this.isEnabled = data.isEnabled || false;
    this.phone = data.phone || false;
    this.massaratValue = data.massaratValue || null;
    this.appVersion = data.appVersion || null;
    this.appPlatform = data.appPlatform || null;
    this.appBuildNumber = data.appBuildNumber || null;
    this.appVersionUpdatedAt = data.appVersionUpdatedAt || null;
  }
}
export default defineComponent({
  data() {
    return {
      students: [],
      showPopupPassword: false,
      showPopupChangeDetiles: false,
      password: '',
      confirmPassword: '',
      userIndex: '',
      showPassword: false,
      passwordError: '',
      passwordSuccess: true,
      confirmPasswordError: '',
      sessionsId: '',
      masterSessionValue: "",
      masterSessionsList: [],
      errorMessage: "عذرا لا يوجد للدارسين مسجلين مع المعلم ",
      errorMessageStatus: false,
      email: '',
      phone: '',
      emailError: "",
      isLoading: false,
      isLoadingSessions: false,
    }
  },
  mounted() {
    this.getMasterSessions();
  },
  methods: {
    async getAllNewStudents() {
      // Set loading state
      this.isLoading = true;
      
      // Clear previous students and errors
      this.students = [];
      this.errorMessageStatus = false;
      
      // Check if a session is selected
      if (!this.sessionsId) {
        this.errorMessageStatus = true;
        this.errorMessage = "الرجاء اختيار الجلسة أولاً";
        this.isLoading = false;
        return;
      }

      try {
        console.log('Fetching students for session:', this.sessionsId);
        const response = await axios.get(process.env.VUE_APP_SERVICE_URL + url.get_all_students,
          {
            params: {
              isNew: '0',
              isDeactivated: '0',
              sessionId: this.sessionsId,
              page: 0,
              size: 1000, // Large size to get all records
            },
            headers: {
              'X-Authorization': localStorage.getItem('token'),
            },
          },
        );
        
        console.log('API Response:', response.data);
        
        // Handle paginated response format
        const responseData = response.data.result.data;
        const studentsArray = responseData.content || responseData; // Handle both old and new formats
        
        if (!studentsArray || studentsArray.length === 0) {
          this.errorMessageStatus = true;
          this.errorMessage = "لا توجد للدارسين مفعلين في هذه الجلسة";
          return;
        }
        
        this.students = studentsArray.map(studentData => new StudentDto(studentData));
        console.log('Active students loaded:', this.students.length);
        
        // Load inactive students as well
        await this.getStudentNotActive();
        
        this.errorMessageStatus = false;
      } catch (error) {
        this.errorMessageStatus = true;
        this.errorMessage = "خطأ في جلب بيانات الدارسين";
        console.error('Error fetching students:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async onClickStatusOfCanWithdraw(index, statusOfCanWithdraw) {
      let studentId = this.students[index].id;
      let status = statusOfCanWithdraw ? "1" : "0";

      try {
        const response = await axios.put(process.env.VUE_APP_SERVICE_URL + url.withdrawalStatus + studentId + "?enable=" + status,
          {},
          {
            headers: {
              'X-Authorization': localStorage.getItem('token'),
            },
          },
        );
        if (response.status == 200) {
          this.students[index].canWithdraw = statusOfCanWithdraw
        }
      } catch (error) {
        console.error(error);
      }

    },
    async onClickStatusOfStudent(index, isEnabled) {
      let studentId = this.students[index].id;
      let status = isEnabled ? "1" : "0";

      try {
        const response = await axios.put(process.env.VUE_APP_SERVICE_URL + url.userStatus + studentId + "?enable=" + status,
          {},
          {
            headers: {
              'X-Authorization': localStorage.getItem('token'),
            },
          },
        );
        if (response.status == 200) {
          this.students[index].isEnabled = isEnabled
        }
      } catch (error) {
        console.error(error);
      }

    },
    async getStudentNotActive() {
      // Don't fetch if no session is selected
      if (!this.sessionsId) {
        return;
      }

      try {
        console.log('Fetching inactive students for session:', this.sessionsId);
        const response = await axios.get(process.env.VUE_APP_SERVICE_URL + url.get_all_students,
          {
            params: {
              isNew: '0',
              isDeactivated: '1',
              sessionId: this.sessionsId,
              page: 0,
              size: 1000, // Large size to get all records
            },
            headers: {
              'X-Authorization': localStorage.getItem('token'),
            },
          },
        );
        
        // Handle paginated response format
        const responseData = response.data.result.data;
        const studentsArray = responseData.content || responseData; // Handle both old and new formats
        
        if (studentsArray && studentsArray.length > 0) {
          console.log('Inactive students loaded:', studentsArray.length);
          studentsArray.forEach(studentData => {
            this.students.push(new StudentDto(studentData));
          });
        }
      } catch (error) {
        console.error('Error fetching inactive students:', error);
      }
    },
    openPopupPassword(index) {
      this.showPopupPassword = true;
      this.passwordSuccess = true;
      this.password = '';
      this.confirmPassword = '';
      this.userIndex = index;
    },
    openPopupChangeDetiles(index) {
      this.showPopupChangeDetiles = true;
      this.userIndex = index;
      this.phone = this.students[this.userIndex].phone;
      this.email = this.students[this.userIndex].email;
    },
    closePopup() {
      this.showPopupPassword = false;
      this.showPopupChangeDetiles = false;
      this.password = '';
      this.confirmPassword = '';
    },
    async submitPassword() {
      if (this.password !== this.confirmPassword) {
        //todo here need to check 
      } else {
        let userId = this.students[this.userIndex].id;
        try {
          const response = await axios.put(process.env.VUE_APP_SERVICE_URL + url.changePassword + userId + "?newPassword=" + btoa(this.password),
            {
            },
            {
              headers: {
                'X-Authorization': localStorage.getItem('token'),
              },
            },
          );
          console.log(response);
          if (response.status == 200) {
            alert("تم تغيير الرقم السري بنجاح!");
            this.closePopup();
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    async submitDetiles() {
      let userId = this.students[this.userIndex].id;
      try {
        const response = await axios.put(process.env.VUE_APP_SERVICE_URL + url.change_email_phone,
          {
            "email": this.email,
            "phone": this.phone,
            "userId": userId,
          },
          {
            headers: {
              'X-Authorization': localStorage.getItem('token'),
            },
          },
        );
        console.log(response);
        if (response.status == 200) {
          alert("تم تغيير البيانات بنجاح!");
          this.closePopup();
          this.getMasterSessions();
        }
      } catch (error) {
        console.error(error);
      }
    },
    validatePassword() {
      // Reset error messages
      this.passwordError = '';
      this.confirmPasswordError = '';

      const specialCharRegex = /[@#!]/i;
      const uppercaseRegex = /[A-Z]/;
      const lowercaseRegex = /[a-z]/;
      const numberRegex = /[0-9]/;

      if (specialCharRegex.test(this.password) && uppercaseRegex.test(this.password) &&
        lowercaseRegex.test(this.password) && numberRegex.test(this.password)) {
        if (this.password !== this.confirmPassword && this.confirmPassword) {
          this.confirmPasswordError = 'كلمة المرور غير متطابقة';
          this.passwordSuccess = true;
        }
        else {
          this.passwordSuccess = false;
        }
      } else if (this.password) {
        this.passwordError =
          'الرقم السري يجب أن يكون بين 8 و 15 حرفا, الرقم السري يجب أن يكون مكون من علامة مميزة مثل "@#!" , يجب أن تحتوي كلمة المرور على أحرف كبيرة و صغيرة';
        this.passwordSuccess = true;
      }
    },
    validateEmail() {
      // Regular expression for basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.email) && this.email.length != 0) {
        this.emailError = "الرجاء ادخال الايميل بشكل صحيح";
      } else {
        this.emailError = "";
      }
    },
    changeSessionsId(masterSessionValue) {
      console.log('Session changed to ID:', masterSessionValue);
      
      // Find the session by ID instead of using array index
      const selectedSession = this.masterSessionsList.find(session => session.id === masterSessionValue);
      if (selectedSession) {
        this.sessionsId = selectedSession.sessionsId;
        console.log('Selected session UUID:', this.sessionsId);
        console.log('Selected session name:', selectedSession.sessionsName);
        
        // Clear previous error status
        this.errorMessageStatus = false;
        
        // Reload students when session changes
        this.getAllNewStudents();
      } else {
        console.error('Session not found for ID:', masterSessionValue);
        this.errorMessageStatus = true;
        this.errorMessage = "خطأ في اختيار الجلسة";
      }
    },
    getMasterSessions() {
      console.log('Fetching master sessions...');
      
      axios.get(process.env.VUE_APP_SERVICE_URL + url.master_sessions, {
        headers: {
          'X-Authorization': localStorage.getItem('token'),
        }
      })
        .then(response => {
          console.log('Master sessions response:', response.data);
          
          this.masterSessionsList = response.data.result.data.map(data => new masterSessionsDto(data));
          console.log('Mapped sessions:', this.masterSessionsList);
          
          if (this.masterSessionsList && this.masterSessionsList.length > 0) {
            // Initialize with first session
            this.masterSessionValue = this.masterSessionsList[0].id;
            this.sessionsId = this.masterSessionsList[0].sessionsId;
            
            console.log('Initialized with session:', {
              id: this.masterSessionValue,
              uuid: this.sessionsId,
              name: this.masterSessionsList[0].sessionsName
            });
            
            // Load students for the first session
            this.getAllNewStudents();
          } else {
            console.warn('No sessions found');
            this.errorMessageStatus = true;
            this.errorMessage = "لا توجد جلسات متاحة";
          }
        })
        .catch(error => {
          console.error('Error fetching sessions:', error);
          this.errorMessageStatus = true;
          this.errorMessage = "خطأ في جلب الجلسات";
        });
    },
    formatDate(dateString) {
      if (!dateString) return '';
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('ar-SA', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (e) {
        return dateString;
      }
    },
  }
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Tailwind utility classes for enabled and disabled button states */
.enabled-button {
  @apply px-4 py-2 bg-primary text-white rounded hover:bg-hafadh-olive-dark w-20 h-10;
}

.disabled-button {
  @apply px-4 py-2 bg-gray-300 text-gray-500 rounded cursor-not-allowed w-20 h-10;
}

.button-background {
  @apply bg-primary;
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-content {
  @apply bg-white p-5 rounded-lg;
  width: 580px;
  height: 380px;
  text-align: center;
}

.button {
  @apply px-4 py-2 bg-primary text-white rounded hover:bg-hafadh-olive-dark w-20 h-10;
}
</style>